import {request} from "@/network/request";

export function DelPhyTestById(id) {
  return request({
    url: 'PhyTest/DelPhyTestById',
    params: {
      id
    }
  })
}

export function getPhyTestList(years, months, days) {
  return request({
    url: 'PhyTest/PhyTestList',
    params: {
      years, months, days
    }
  })
}

export function AddPhyTest(title, location, notice, maxp, conditions, start, open, close, dates) {
  return request({
    url: 'PhyTest/AddPhyTest',
    params: {
      title, location, notice, maxp, conditions, start, open, close, dates,
    }
  })
}

export function GetPhyTestCountById(pid) {
  return request({
    url: 'PhyTest/GetPhyTestCountById',
    params: {
      pid
    }
  })
}
export function GetPhyTestCalendarList() {
  return request({
    url: 'PhyTest/GetPhyTestCalendarList',
  })
}
